<template>
  <div>
    <main-header :totalMaterials="total"></main-header>

    <main>
      <b-container>
        <div class="row pt-5 mb-4">
          <div class="col">
            <div v-html="htmlContent"></div>
          </div>
        </div>
      </b-container>
      <main-footer></main-footer>
    </main>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import MainFooter from '@/components/MainFooter.vue';
import axios from 'axios';

export default {
  components: {
    MainFooter,
    MainHeader,
  },
  data() {
    return {
      total: {
        all: null,
        sm: null,
        ti: null,
        trivial: null,
      },
      htmlContent: '',
    };
  },
  computed: {

  },
  created() {
    axios.get('/external/predict.html').then((result) => {
      this.htmlContent = result.data;
    });
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>

</style>
